<template>
	<div class="width-100 height-100 flex-centerize">
		<AppLoader v-if="isLoading" />
		<div v-else-if="showErrorMessage">Something went wrong. Please try again later</div>
		<Row v-else class="flex-align-center">
			<h3>Done</h3>
			<AppIcon class="ml-1" name="successfull-connection" size="18" height="18" />
		</Row>
	</div>
</template>

<script>
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { requestFeatureAccess } from '@/store/modules/billing/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
import { modeToParamsMap } from '@/utils/run-workflow-restriction-service';
export default {
	name: 'ExtensionRunFlowRestricted',
	props: {
		mode: { type: Number },
		hashId: { type: String },
	},
	methods: {
		...mapActionsShorthand({ requestFeatureAccess }),
		requestAccess() {
			return this.requestFeatureAccess({ hashId: this.hashId });
		},
	},
	async created() {
		ExtensionCommunicationService.notifyExtensionPageCreated();
		await AppDialogManagerService.openRunFailInfoDialog(modeToParamsMap(this.requestAccess)[this.mode]);
		ExtensionCommunicationService.closeWizard(window);
	},

	data() {
		return {
			isLoading: false,
			showErrorMessage: false,
		};
	},
};
</script>
